import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes for the admin section, specifying paths using baseRoutes from the "helpers/baseRoutes" module.
 * Each route has a unique identifier and a corresponding path.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  ADMIN_PROFILE: {
    path: `${baseRoutes.adminBaseRoutes}/profile`,
  },
  ADMIN_CHANGE_PASSWORD: {
    path: `${baseRoutes.adminBaseRoutes}/change-password`,
  },
  ADMIN_NOTIFICATIONS: {
    path: `${baseRoutes.adminBaseRoutes}/notifications`,
  },
};

export default accessRoute;
